module.exports = __webpack_public_path__ + "templates/about-who.html";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/about/templates/about-who.html
// module id = c+Xz
// module chunks = 1